import React, { useState } from 'react';

const PACKAGES = [
  { id: 'starter', name: 'Starter', credits: 10, price: 'Rp 15.000', priceNum: 15000, per: 'Rp 1.500/generate' },
  { id: 'regular', name: 'Regular', credits: 30, price: 'Rp 40.000', priceNum: 40000, per: 'Rp 1.333/generate', popular: true },
  { id: 'power', name: 'Power', credits: 100, price: 'Rp 100.000', priceNum: 100000, per: 'Rp 1.000/generate', bonus: 'Hemat 33%' },
];

export default function TopupModal({ onClose, currentBalance, onSuccess }) {
  const [selected, setSelected] = useState('regular');
  const [step, setStep] = useState(1); // 1=pilih, 2=instruksi bayar

  const pkg = PACKAGES.find(p => p.id === selected);

  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.8)', zIndex:200, display:'flex', alignItems:'center', justifyContent:'center', padding:16 }}>
      <div style={{ background:'#111827', border:'1px solid #1e2d45', borderRadius:16, width:'100%', maxWidth:480, maxHeight:'90vh', overflowY:'auto' }}>
        
        {/* Header */}
        <div style={{ padding:'20px 24px', borderBottom:'1px solid #1e2d45', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
          <div>
            <h3 style={{ color:'#f1f5f9', fontSize:16, fontWeight:700 }}>✨ Top Up Kredit AI</h3>
            <p style={{ color:'#64748b', fontSize:12, marginTop:2 }}>Saldo saat ini: <span style={{ color:'#f59e0b', fontWeight:600 }}>{currentBalance} kredit</span></p>
          </div>
          <button onClick={onClose} style={{ background:'transparent', border:'none', color:'#64748b', fontSize:20, cursor:'pointer' }}>×</button>
        </div>

        <div style={{ padding:24 }}>
          {step === 1 && (
            <>
              <p style={{ color:'#94a3b8', fontSize:13, marginBottom:20 }}>
                Gunakan kredit untuk generate deskripsi & tags SEO otomatis dengan AI. 
                <strong style={{ color:'#f59e0b' }}> 1 kredit = 1x generate.</strong>
              </p>

              {/* Packages */}
              <div style={{ display:'flex', flexDirection:'column', gap:10, marginBottom:20 }}>
                {PACKAGES.map(p => (
                  <div key={p.id} onClick={() => setSelected(p.id)}
                    style={{ padding:'14px 16px', borderRadius:10, cursor:'pointer', border:`2px solid ${selected===p.id ? '#f59e0b' : '#1e2d45'}`, background: selected===p.id ? '#1a2235' : 'transparent', position:'relative', transition:'all 0.2s' }}>
                    {p.popular && <span style={{ position:'absolute', top:-10, right:12, background:'#f59e0b', color:'#000', fontSize:10, fontWeight:700, padding:'2px 8px', borderRadius:999 }}>POPULER</span>}
                    {p.bonus && <span style={{ position:'absolute', top:-10, right:12, background:'#10b981', color:'#000', fontSize:10, fontWeight:700, padding:'2px 8px', borderRadius:999 }}>{p.bonus}</span>}
                    <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                      <div>
                        <div style={{ fontWeight:600, color:'#f1f5f9', fontSize:15 }}>{p.name} — <span style={{ color:'#f59e0b' }}>{p.credits} kredit</span></div>
                        <div style={{ fontSize:12, color:'#64748b', marginTop:2 }}>{p.per}</div>
                      </div>
                      <div style={{ fontSize:18, fontWeight:700, color:'#f1f5f9' }}>{p.price}</div>
                    </div>
                  </div>
                ))}
              </div>

              <div style={{ background:'#1a2235', borderRadius:10, padding:'12px 16px', marginBottom:20, fontSize:13, color:'#94a3b8' }}>
                💡 <strong style={{ color:'#f1f5f9' }}>Cara kerja AI:</strong> Masukkan judul video → klik ✨ AI Generate → sistem otomatis buat deskripsi SEO + tags viral dalam Bahasa Indonesia
              </div>

              <button onClick={() => setStep(2)}
                style={{ background:'linear-gradient(135deg,#f59e0b,#fbbf24)', color:'#000', padding:'12px', border:'none', borderRadius:10, fontWeight:700, fontSize:15, cursor:'pointer', width:'100%' }}>
                Lanjut Bayar {pkg.price} →
              </button>
            </>
          )}

          {step === 2 && (
            <>
              <div style={{ textAlign:'center', marginBottom:20 }}>
                <div style={{ fontSize:40, marginBottom:8 }}>💳</div>
                <h4 style={{ color:'#f1f5f9', fontSize:16, marginBottom:4 }}>Transfer ke Rekening Kami</h4>
                <p style={{ color:'#64748b', fontSize:13 }}>Paket <strong style={{ color:'#f59e0b' }}>{pkg.name} ({pkg.credits} kredit)</strong></p>
              </div>

              <div style={{ background:'#1a2235', border:'1px solid #f59e0b', borderRadius:10, padding:20, marginBottom:16 }}>
                <div style={{ textAlign:'center', marginBottom:16 }}>
                  <div style={{ fontSize:28, fontWeight:800, color:'#f59e0b' }}>{pkg.price}</div>
                  <div style={{ fontSize:12, color:'#64748b' }}>Jumlah transfer</div>
                </div>
                <div style={{ display:'flex', flexDirection:'column', gap:10, fontSize:14 }}>
                  {[
                    ['Bank', 'BCA / BRI / BSI'],
                    ['Atas Nama', 'Muhammad Faizal'],
                    ['No. Rekening', '(hubungi admin)'],
                  ].map(([k,v]) => (
                    <div key={k} style={{ display:'flex', justifyContent:'space-between' }}>
                      <span style={{ color:'#64748b' }}>{k}</span>
                      <span style={{ color:'#f1f5f9', fontWeight:500 }}>{v}</span>
                    </div>
                  ))}
                </div>
              </div>

              <div style={{ background:'#0a2218', border:'1px solid #10b981', borderRadius:10, padding:14, marginBottom:20, fontSize:13, color:'#94a3b8' }}>
                📱 Setelah transfer, kirim bukti ke Telegram <a href="https://t.me/FZL420" target="_blank" rel="noreferrer" style={{ color:'#10b981', fontWeight:600 }}>@FZL420</a> dengan format:<br/>
                <code style={{ color:'#10b981', display:'block', marginTop:6 }}>TOP UP AI [email kamu] [paket]</code>
              </div>

              <div style={{ display:'flex', gap:10 }}>
                <button onClick={() => setStep(1)} style={{ flex:1, padding:'10px', background:'transparent', border:'1px solid #1e2d45', borderRadius:8, color:'#94a3b8', cursor:'pointer' }}>← Kembali</button>
                <a href="https://t.me/FZL420" target="_blank" rel="noreferrer"
                  style={{ flex:2, padding:'10px', background:'linear-gradient(135deg,#f59e0b,#fbbf24)', borderRadius:8, color:'#000', fontWeight:700, textDecoration:'none', textAlign:'center', fontSize:14 }}>
                  📱 Konfirmasi ke @FZL420
                </a>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
